export default {
    USER: 1000,
    SYS_ADMIN: 1001,
    CALC_EXCESS: 1002,
    UPDATE_CARDPAYMENT_STATUS: 1003,
    VIEW_TASK_HISTORY: 1004,
    RESET_POLICY: 1007,
    CLAIMS_AGENT_TRAINEE: 1009,
    CLAIMS_AGENT: 1010,
    CLAIMS_AGENT_SENIOR: 1015,
    CLAIMS_TEAM_LEADER: 1011,
    CLAIMS_MANAGER: 1012,
    READONLY: 1013
}